// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nQ-z","hovered":"oQ-z","hoverImage":"pQ-z","mainImage":"qQ-z","imageNoBackground":"rQ-z","fullSizeImage":"sQ-z"};